import React, { Component } from "react";
import LoginFediverse from "../components/LoginFediverse";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { RiPixelfedFill } from 'react-icons/ri';
import * as Constants from '../Constants';

export default class Main extends Component {

  constructor(props) {

    super(props);

    this.state = {}

    let jwt = localStorage.getItem('jwt');

    if (!jwt) {
        window.location.href = "/"
    }
  }

  render() {
    return (
      <div className="content">
        <Header />
        <div className="mt-4"/>
        <h3 className="text-center logo-gradient">2. Login with Pixelfed</h3>
        <div className="mt-4"/>
        <LoginFediverse
          type="Pixelfed"
          placeholder="Example: pixelfed.social"
          url={Constants.URL_BASE + "/redirect-pixelfed"}
          icon=<RiPixelfedFill size={18} className="react-icon-fix"/> 
          permision="read+follow"
          disclaimer={true}
          />
        <Footer />
    </div>
    );
  }
}